import { render, staticRenderFns } from "./WealthConfig.vue?vue&type=template&id=58999e7f&scoped=true"
import script from "./WealthConfig.vue?vue&type=script&lang=ts"
export * from "./WealthConfig.vue?vue&type=script&lang=ts"
import style0 from "./WealthConfig.vue?vue&type=style&index=0&id=58999e7f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58999e7f",
  null
  
)

export default component.exports